"use strict";

var _regeneratorRuntime = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.copyToClipboard = void 0;

var log_1 = require("./log");

function copyToClipboard(content) {
  var parentWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var permissionResult;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return parentWindow.navigator.permissions.query({
              name: 'clipboard-write'
            });

          case 3:
            permissionResult = _context.sent;
            _context.next = 6;
            return parentWindow.navigator.clipboard.readText();

          case 6:
            if (!(permissionResult.state === 'granted')) {
              _context.next = 9;
              break;
            }

            _context.next = 9;
            return parentWindow.navigator.clipboard.writeText(content);

          case 9:
            return _context.abrupt("return", true);

          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            (0, log_1.error)('error copying to clipboard');
            (0, log_1.error)(_context.t0);
            return _context.abrupt("return", false);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 12]]);
  }));
}

exports.copyToClipboard = copyToClipboard;